import React from "react";
import tripRequestLogo from "../../assets/images/trip_request_icon.svg";
import { Link } from "react-router-dom";
import CommonHeader from "../../components/elements/CommonHeader";
import ROUTE_PATHS from "../../utils/routePaths";

const TripDetailsHeader = ({ currentPage, fromScreen }) => {
  return (
    <CommonHeader
      centerLogoSrc={tripRequestLogo}
      headerText="Trip Requests"
      backContent={
        <div className="navigation-header">
          <Link
            to={
              fromScreen === "notifications"
                ? ROUTE_PATHS.NOTIFICATIONS_PAGE
                : ROUTE_PATHS.TRIP_REQUEST_PAGE
            }
            state={
              fromScreen === "notifications"
                ? { currentPage, fromNotifications: true }
                : { currentPage }
            }
            className="navigation-header-link"
          >
            Home/
          </Link>
          Trip Requests
        </div>
      }
    />
  );
};

export default TripDetailsHeader;
